import React, { Fragment } from "react";
import { onClickPopulateFields } from "../utilities";

function TreesToHypertext(props) {
  const { notPastWeekObs, baseUrl, formik, handleClose } = props;

  let populate = [];
  for (let i = 0; i < notPastWeekObs.length; i++) {
    populate.push(
      <li className="treesListItem">
        <a 
          className="treesListAnchor"
          href="#"
          onClick={() => {
            onClickPopulateFields(baseUrl, formik, notPastWeekObs[i]);
            handleClose();
          }}
        >
          <div>
            <span> PlantID: {notPastWeekObs[i].plantId}  </span>
            <span> Genus: {notPastWeekObs[i].genus}  </span>
            <span> List: {notPastWeekObs[i].list}  </span>
          </div>
        </a>
      </li>
    );
  }

  return <Fragment>{populate}</Fragment>;
}

export default TreesToHypertext;
